var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.64 12.061 3.231 2.275a.625.625 0 0 0 .879-.572v-7.53a.625.625 0 0 0-.879-.57l-3.23 2.274a.63.63 0 0 0-.266.51v3.102a.62.62 0 0 0 .265.511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.469 14.999H3.28a2.037 2.037 0 0 1-2.031-2.032V7.03a2.037 2.037 0 0 1 2.031-2.031h7.207A2.02 2.02 0 0 1 12.5 7.01v5.956a2.037 2.037 0 0 1-2.031 2.031Z"
  })));
};
export { SvgVideo as ReactComponent };